{
  "name": "business",
  "version": "2.26.0",
  "scripts": {
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "prepare": "husky",
    "prebuild": "./prebuild",
    "pretest": "./prebuild"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/forms": "^19.2.14",
    "@angular/localize": "^19.2.14",
    "@angular/material": "^19.2.19",
    "@angular/material-moment-adapter": "^19.2.19",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/router": "^19.2.14",
    "@angular/service-worker": "^19.2.14",
    "@auth0/auth0-angular": "^2.7.0",
    "@microsoft/fetch-event-source": "^2.0.1",
    "@ngneat/input-mask": "^6.1.0",
    "@ngrx/component": "^19.2.1",
    "@ngrx/effects": "^19.2.1",
    "@ngrx/operators": "^19.2.1",
    "@ngrx/router-store": "^19.2.1",
    "@ngrx/store": "^19.2.1",
    "@ngrx/store-devtools": "^19.2.1",
    "@ngx-translate/core": "^15.0.0",
    "@sentry/angular": "^8.55.0",
    "inputmask": "^5.0.8",
    "libphonenumber-js": "^1.13.10",
    "lodash": "^4.17.21",
    "moment": "^2.30.1",
    "ngx-mask": "^20.0.3",
    "ngx-mat-select-search": "^7.0.7",
    "ngx-toastr": "^19.0.0",
    "pdfjs-dist": "^4.10.38",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-builders/jest": "^19.0.1",
    "@angular-eslint/builder": "19.8.1",
    "@angular-eslint/eslint-plugin": "19.8.1",
    "@angular-eslint/eslint-plugin-template": "19.8.1",
    "@angular-eslint/schematics": "19.8.1",
    "@angular-eslint/template-parser": "19.8.1",
    "@angular/build": "^19.2.15",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.14",
    "@types/inputmask": "^5.0.7",
    "@types/jest": "^29.5.12",
    "@types/lodash": "^4.17.0",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "eslint": "^8.57.0",
    "husky": "^9.0.11",
    "jest": "^29.7.0",
    "jest-extended": "^4.0.1",
    "jest-preset-angular": "^14.0.3",
    "tailwindcss": "^3.4.1",
    "ts-node": "^10.9.2",
    "typescript": "~5.5.4"
  }
}
